import { render, staticRenderFns } from "./createStatus.vue?vue&type=template&id=4f40c2c2&scoped=true&"
import script from "./createStatus.vue?vue&type=script&lang=js&"
export * from "./createStatus.vue?vue&type=script&lang=js&"
import style0 from "./createStatus.vue?vue&type=style&index=0&id=4f40c2c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f40c2c2",
  null
  
)

export default component.exports